import axios from 'axios';
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Report, ReportData, ReportElement } from '@/models/ReportElement';
import { Vue } from 'vue-property-decorator';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
export interface IReports {
    [formUri: string]: Report;
}
@Module({ namespaced: true })
class ReportModule extends VuexModule {
    _all: IReports = {};

    get all(): IReports {
        return this._all;
    }

    @Mutation
    add(report: Report) {
        Vue.set(this._all, report.form, report);
    }

    @Mutation
    addElement(element: ReportElement) {
        Vue.set(this._all[element.form].elements, element.weight, element);
    }

    @Mutation
    set(report: Report) {
        Vue.set(this._all, report.form, report);
    }

    @Mutation
    setElement(element: ReportElement) {
        const index = this._all[element.form].elements.findIndex((e: ReportElement) => e.id === element.id);
        Vue.set(this._all[element.form].elements, index, element);
    }

    @Mutation
    remove(report: Report) {
        Vue.delete(this._all, report.form);
    }

    @Mutation
    removeElement(element: ReportElement) {
        const index = this._all[element.form].elements.findIndex((e: ReportElement) => e.id === element.id);
        Vue.delete(this._all[element.form].elements, index);
    }

    @Action
    async read(form: number) {
        try {
            const r = await axios({
                method: 'GET',
                url: `/api/reports?form=${form}`,
            });
            return r.data['hydra:member'].map((data: ReportData) => {
                this.context.commit('add', new Report(data));
            });
        } catch (e) {
            return e;
        }
    }

    @Action
    async create(formUri: string) {
        try {
            const r = await axios({
                method: 'POST',
                url: '/api/reports',
                data: {
                    form: formUri,
                },
            });
            this.context.commit('add', new Report(r.data));
        } catch (e) {
            return e;
        }
    }

    @Action
    async update(data: Report) {
        try {
            await axios({
                method: 'PUT',
                url: `/api/reports/${data.id}`,
                responseType: 'json',
                headers: {
                    'accept': 'application/ld+json',
                    'content-type': 'application/ld+json',
                },
                data,
            });

            const r = await axios({
                method: 'GET',
                url: `/api/reports/${data.id}`,
            });

            if (r.status !== 200) {
                throw Error('Report UPDATE failed.');
            }

            this.context.commit('set', new Report(r.data));
        } catch (e) {
            return e;
        }
    }

    @Action
    async delete(data: Report) {
        try {
            const r = await axios({
                method: 'DELETE',
                url: `/api/reports/${data.id}`,
            });

            if (r.status !== 204) {
                throw Error('Report DELETE failed.');
            }

            this.context.commit('remove', data);
        } catch (e) {
            return e;
        }
    }
}

export default ReportModule;
